import React, { useState } from 'react';
import { ReviewsCounts } from '../../../../../hooks/useUserReviewsQuery';
import { SegmentedControl, Stack } from '@primer/react';

interface UserViewSegmentProps {
    counter: ReviewsCounts
    tabChanged: (type: UserReviewType) => void;
}

export enum UserReviewType {
    fromBuyers = "fromBuyers",
    fromSellers = "fromSellers",
}

interface TabData {
    text: string;
    type: UserReviewType;
    isActive: boolean;
}

const UserReviewsSegment: React.FC<UserViewSegmentProps> = ({ counter, tabChanged }) => {

    const [userReviewsTabsData, setUserReviewsTabsData] = useState<TabData[]>([
        {
            text: `От покупателей (${counter.fromBuyers})`,
            type: UserReviewType.fromBuyers,
            isActive: true
        },
        {
            text: `От продавцов (${counter.fromSellers})`,
            type: UserReviewType.fromSellers,
            isActive: false
        }
    ]);


    const handleTabClick = (selectedType: UserReviewType) => {
        setUserReviewsTabsData(prev =>
            prev.map(tab => ({
                ...tab,
                isActive: tab.type === selectedType
            }))
        );

        tabChanged(selectedType);
    };

    return (
        <Stack justify="space-between" direction="horizontal">
            <Stack direction="horizontal">
                <SegmentedControl aria-label="Отзывы">
                    {userReviewsTabsData.map((tab, index) => (
                        <SegmentedControl.Button
                            key={index}
                            defaultSelected={tab.isActive}
                            onClick={() => handleTabClick(tab.type)}
                        >
                            {tab.text}
                        </SegmentedControl.Button>
                    ))}
                </SegmentedControl>
            </Stack>
        </Stack>
    )
}

export default UserReviewsSegment